import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seo_check_box_cell = _resolveComponent("seo-check-box-cell");
  const _component_seo_product_cell = _resolveComponent("seo-product-cell");
  const _component_seo_item_highlight_cell = _resolveComponent("seo-item-highlight-cell");
  const _component_seo_bullet_point_cell = _resolveComponent("seo-bullet-point-cell");
  const _component_seo_search_terms_cell = _resolveComponent("seo-search-terms-cell");
  const _component_seo_description_cell = _resolveComponent("seo-description-cell");
  const _component_seo_a_plus_cell = _resolveComponent("seo-a-plus-cell");
  const _component_seo_images_count_cell = _resolveComponent("seo-images-count-cell");
  const _component_seo_image_cell = _resolveComponent("seo-image-cell");
  const _component_seo_category_cell = _resolveComponent("seo-category-cell");
  const _component_seo_brand_cell = _resolveComponent("seo-brand-cell");
  const _component_seo_amazon_score_cell = _resolveComponent("seo-amazon-score-cell");
  const _component_seo_omny_score_cell = _resolveComponent("seo-omny-score-cell");
  const _component_seo_push_status_cell = _resolveComponent("seo-push-status-cell");
  const _component_seo_pencil_edit_cell = _resolveComponent("seo-pencil-edit-cell");
  const _component_b_tr = _resolveComponent("b-tr");
  return _openBlock(), _createBlock(_component_b_tr, {
    class: "seo-row"
  }, {
    default: _withCtx(() => [$props.showCheckBox ? (_openBlock(), _createBlock(_component_seo_check_box_cell, {
      key: 0,
      item: $props.item,
      onSelectItem: _cache[0] || (_cache[0] = val => _ctx.$emit('selectItem', val)),
      isSelectedItem: _ctx.isSelectedItem($props.item),
      disabled: $props.isCheckBoxDisabled
    }, null, 8, ["item", "isSelectedItem", "disabled"])) : _createCommentVNode("", true), _createVNode(_component_seo_product_cell, {
      onOnEdit: _cache[1] || (_cache[1] = val => _ctx.$emit('onEdit', val)),
      item: $props.item,
      pushModal: $props.pushModal,
      showCheckBox: $props.showCheckBox,
      showPopover: $props.showPopover,
      uid: `${$options.uid}-product_name`,
      index: $props.index,
      onOnCopyingHover: _cache[2] || (_cache[2] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[3] || (_cache[3] = val => _ctx.$emit('onCopyingHoverLeave', val))
    }, null, 8, ["item", "pushModal", "showCheckBox", "showPopover", "uid", "index"]), _createVNode(_component_seo_item_highlight_cell, {
      highlight: {
        text: $props.item.item_highlight,
        ui_style: $props.item.item_highlight_style,
        icon: $props.item.item_highlight_icon,
        id: `${$options.uid}-item_highlight`,
        type: 'item_highlight',
        title: 'Item highlight'
      },
      item: $props.item,
      onOnEdit: _cache[4] || (_cache[4] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[5] || (_cache[5] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[6] || (_cache[6] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[7] || (_cache[7] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[8] || (_cache[8] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["highlight", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_bullet_point_cell, {
      bullet_point: {
        text: $props.item.bullet_point_1,
        ui_style: $props.item.bullet_point_1_style,
        icon: $props.item.bullet_point_1_icon,
        id: `${$options.uid}-bullet_point_1`,
        type: 'bullet_point_1',
        title: 'Bullet Point #1'
      },
      item: $props.item,
      onOnEdit: _cache[9] || (_cache[9] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[10] || (_cache[10] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[11] || (_cache[11] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[12] || (_cache[12] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[13] || (_cache[13] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["bullet_point", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_bullet_point_cell, {
      bullet_point: {
        text: $props.item.bullet_point_2,
        ui_style: $props.item.bullet_point_2_style,
        icon: $props.item.bullet_point_2_icon,
        id: `${$options.uid}-bullet_point_2`,
        type: 'bullet_point_2',
        title: 'Bullet Point #2'
      },
      item: $props.item,
      onOnEdit: _cache[14] || (_cache[14] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[15] || (_cache[15] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[16] || (_cache[16] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[17] || (_cache[17] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[18] || (_cache[18] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["bullet_point", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_bullet_point_cell, {
      bullet_point: {
        text: $props.item.bullet_point_3,
        ui_style: $props.item.bullet_point_3_style,
        icon: $props.item.bullet_point_3_icon,
        id: `${$options.uid}-bullet_point_3`,
        type: 'bullet_point_3',
        title: 'Bullet Point #3'
      },
      item: $props.item,
      onOnEdit: _cache[19] || (_cache[19] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[20] || (_cache[20] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[21] || (_cache[21] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[22] || (_cache[22] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[23] || (_cache[23] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["bullet_point", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_bullet_point_cell, {
      bullet_point: {
        text: $props.item.bullet_point_4,
        ui_style: $props.item.bullet_point_4_style,
        icon: $props.item.bullet_point_4_icon,
        id: `${$options.uid}-bullet_point_4`,
        type: 'bullet_point_4',
        title: 'Bullet Point #4'
      },
      item: $props.item,
      onOnEdit: _cache[24] || (_cache[24] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[25] || (_cache[25] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[26] || (_cache[26] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[27] || (_cache[27] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[28] || (_cache[28] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["bullet_point", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_bullet_point_cell, {
      bullet_point: {
        text: $props.item.bullet_point_5,
        ui_style: $props.item.bullet_point_5_style,
        icon: $props.item.bullet_point_5_icon,
        id: `${$options.uid}-bullet_point_5`,
        type: 'bullet_point_5',
        title: 'Bullet Point #5'
      },
      item: $props.item,
      onOnEdit: _cache[29] || (_cache[29] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[30] || (_cache[30] = val => _ctx.$emit('isCopied', val)),
      index: $props.index,
      onOnCopyingHover: _cache[31] || (_cache[31] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[32] || (_cache[32] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying,
      onOnPaste: _cache[33] || (_cache[33] = val => _ctx.$emit('onPaste', val)),
      showPopover: $props.showPopover
    }, null, 8, ["bullet_point", "item", "index", "isCopying", "showPopover"]), _createVNode(_component_seo_search_terms_cell, {
      item: $props.item,
      isCopying: $props.isCopying,
      onOnEdit: _cache[34] || (_cache[34] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[35] || (_cache[35] = val => _ctx.$emit('isCopied', val)),
      onOnCopyingHover: _cache[36] || (_cache[36] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[37] || (_cache[37] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      onOnPaste: _cache[38] || (_cache[38] = val => _ctx.$emit('onPaste', val)),
      uid: `${$options.uid}-keyword`,
      index: $props.index,
      showPopover: $props.showPopover
    }, null, 8, ["item", "isCopying", "uid", "index", "showPopover"]), _createVNode(_component_seo_description_cell, {
      item: $props.item,
      isCopying: $props.isCopying,
      onOnEdit: _cache[39] || (_cache[39] = val => _ctx.$emit('onEdit', val)),
      onIsCopied: _cache[40] || (_cache[40] = val => _ctx.$emit('isCopied', val)),
      onOnCopyingHover: _cache[41] || (_cache[41] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[42] || (_cache[42] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      onOnPaste: _cache[43] || (_cache[43] = val => _ctx.$emit('onPaste', val)),
      uid: `${$options.uid}-description`,
      index: $props.index,
      showPopover: $props.showPopover
    }, null, 8, ["item", "isCopying", "uid", "index", "showPopover"]), _createVNode(_component_seo_a_plus_cell, {
      item: $props.item
    }, null, 8, ["item"]), _createVNode(_component_seo_images_count_cell, {
      item: $props.item
    }, null, 8, ["item"]), _createVNode(_component_seo_image_cell, {
      imagesList: $props.item.image_list,
      isCollapsed: $props.isImageCellCollapsed,
      pushModal: $props.pushModal,
      onExpandImageList: _cache[44] || (_cache[44] = $event => _ctx.$emit('expandImageList')),
      onOnCopyingHoverLeave: _cache[45] || (_cache[45] = val => _ctx.$emit('onCopyingHoverLeave', val)),
      isCopying: $props.isCopying
    }, null, 8, ["imagesList", "isCollapsed", "pushModal", "isCopying"]), _createVNode(_component_seo_category_cell, {
      item: $props.item
    }, null, 8, ["item"]), _createVNode(_component_seo_brand_cell, {
      item: $props.item
    }, null, 8, ["item"]), _createVNode(_component_seo_amazon_score_cell, {
      item: $props.item,
      pushModal: $props.pushModal
    }, null, 8, ["item", "pushModal"]), _createVNode(_component_seo_omny_score_cell, {
      item: $props.item,
      pushModal: $props.pushModal
    }, null, 8, ["item", "pushModal"]), _createVNode(_component_seo_push_status_cell, {
      item: $props.item,
      pushModal: $props.pushModal,
      push_loading: $props.push_loading,
      onOnConfirmPushSingleContent: _cache[46] || (_cache[46] = val => _ctx.$emit('onConfirmPushSingleContent', val)),
      showPopover: $props.showPopover,
      onOnCopyingHover: _cache[47] || (_cache[47] = val => _ctx.$emit('onCopyingHover', val)),
      onOnCopyingHoverLeave: _cache[48] || (_cache[48] = val => _ctx.$emit('onCopyingHoverLeave', val))
    }, null, 8, ["item", "pushModal", "push_loading", "showPopover"]), !$props.pushModal ? (_openBlock(), _createBlock(_component_seo_pencil_edit_cell, {
      key: 1,
      item: $props.item,
      push_loading: $props.push_loading,
      onOnEditSingleItem: _cache[49] || (_cache[49] = val => _ctx.$emit('onEditSingleItem', val))
    }, null, 8, ["item", "push_loading"])) : _createCommentVNode("", true)]),
    _: 1
  });
}